// Payment-terms parsing. A customer's `terms` field encodes how many days after
// the invoice date payment is due. The canonical form is `N<days>` (e.g. `N30`),
// with a few cash-equivalent aliases meaning "due immediately" (0 days).
//
// Unparseable / blank / placeholder values return null so the caller can leave
// the due date untouched rather than silently computing a wrong date.
const NET_DAYS = /^N(\d+)$/i;
const CASH_ALIASES = new Set(['COD', 'CASH', 'เงินสด', 'N0']);
/**
 * Parse a customer payment-terms string to a net-days integer.
 *
 * - `N<digits>` (case-insensitive) → that integer (`N30`→30, `N0`→0, `N45`→45).
 * - `COD` / `CASH` / `เงินสด` / `N0` → 0 (due immediately).
 * - anything else / null / undefined / `—` / whitespace → null.
 */
export function parseTermsDays(terms) {
    if (terms == null)
        return null;
    const t = terms.trim();
    if (t === '')
        return null;
    if (CASH_ALIASES.has(t.toUpperCase()))
        return 0;
    const m = NET_DAYS.exec(t);
    if (m)
        return Number.parseInt(m[1], 10);
    return null;
}
//# sourceMappingURL=terms.js.map